export default __webpack_public_path__ + "static/bento-3p13-33dd40759e0d770c51552e0e5e2b71f1.png";